/** Ticket show lengths models can pick when scheduling. */
export const TICKET_DURATION_OPTIONS = [30, 60, 90];
/** VIP and Exclusive are started via the private queue, not by the model directly. */
export const FAN_INITIATED_SHOW_TYPES = ['VIP', 'EXCLUSIVE'];
const TRANSITION_TARGETS = {
    MAIN_STAGE: ['PARTY', 'TICKET', 'CLUB', 'VIP', 'EXCLUSIVE'],
    PARTY: ['VIP', 'EXCLUSIVE'],
    TICKET: [],
    CLUB: [],
    VIP: ['EXCLUSIVE'],
    EXCLUSIVE: [],
    PEEP: [],
};
/** Show types the broadcaster may switch to mid-stream (excludes fan-initiated privates). */
const MODEL_TRANSITION_TARGETS = {
    MAIN_STAGE: ['PARTY', 'TICKET', 'CLUB', 'PEEP'],
    PARTY: [],
    TICKET: [],
    CLUB: [],
    VIP: [],
    EXCLUSIVE: [],
    PEEP: [],
};
/** Show types the broadcaster may choose when first going live. */
export const MODEL_START_SHOW_TYPES = ['MAIN_STAGE', 'PARTY', 'TICKET', 'CLUB', 'PEEP'];
/** Main Stage — public floor with no entry fee. */
export function isPublicMainStage(type) {
    return type === 'MAIN_STAGE';
}
/**
 * Fans may request a private (VIP / Exclusive) from any active show type.
 * Public floor (Main Stage) is the primary entry; other types still enqueue
 * a request for the model to accept or reject.
 */
export function isPrivateQueueJoinable(_type) {
    return true;
}
/** Private queue UI and API are available while the show is active. */
export function isPrivateQueueAvailable(show) {
    if (show.status === 'ENDED') {
        return false;
    }
    // LIVE / WAITING floors and on-break (PAUSED) rooms can take private requests.
    return show.status === 'LIVE' || show.status === 'WAITING' || show.status === 'PAUSED';
}
/** Broadcaster is between private/non-public and a resumed Main Stage. */
export function isShowOnBreak(show) {
    return show.status === 'PAUSED';
}
/** Private show types fans can request via the queue. */
export const FAN_PRIVATE_QUEUE_TYPES = ['VIP', 'EXCLUSIVE'];
export function canTransitionShow(from, to) {
    return TRANSITION_TARGETS[from].includes(to);
}
export function listTransitionTargets(from) {
    return [...TRANSITION_TARGETS[from]];
}
export function listModelTransitionTargets(from) {
    return [...MODEL_TRANSITION_TARGETS[from]];
}
export function isFanInitiatedShowType(type) {
    return FAN_INITIATED_SHOW_TYPES.includes(type);
}
//# sourceMappingURL=showTypes.js.map